// @ts-nocheck
import logger from "@insite/client-framework/Logger";
import { post } from "@insite/client-framework/Services/ApiService";
import { GetProductCollectionRealTimePriceApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { RealTimePricingModel } from "@insite/client-framework/Types/ApiModels";
import { createChainHandler, replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

const realTimePricingUrl = "/api/v1/realtimepricing";

const getProductCollectionRealTimePricesWithCacheBuster = async (
    parameter: GetProductCollectionRealTimePriceApiV2Parameter,
) => {
    const pricing = await post<GetProductCollectionRealTimePriceApiV2Parameter, RealTimePricingModel>(
        `${realTimePricingUrl}`,
        {
            additionalQueryStringParameters: { ...parameter.additionalQueryStringParameters, timestamp: Date.now() },
            productPriceParameters: parameter.productPriceParameters,
        },
    );

    return pricing;
};

export const RequestDataFromApiWithCacheBuster = createChainHandler(
    "RequestDataFromApiWithCacheBuster",
    chain,
    async props => {
        if (!getSettingsCollection(props.getState()).productSettings.canSeePrices) {
            return false;
        }

        try {
            props.apiResult = await getProductCollectionRealTimePricesWithCacheBuster(props.apiParameter);
        } catch (error) {
            if (error.status === 403) {
                // auth timed out with sign in required for pricing - throw this up as a 401 so DisplayError reloads the site
                error.status = 401;
                error.errorJson = { message: "error" };
                throw error;
            } else {
                logger.warn(`Failed to load pricing data: ${error}`);
                props.error = error;
            }
        }
    },
);

replaceInChain(chain, RequestDataFromApi, RequestDataFromApiWithCacheBuster);
